// Aviso in-app de "un ticket cambió de estado" (papelera, spam, validación, restaurar,
// cerrar…). Existe porque las superficies que muestran tickets NO comparten cache: la
// lista usa react-query, pero la burbuja de tickets y el badge del sidebar tienen su
// propio estado con un poll de 60 segundos. Mandar un ticket a la papelera lo sacaba
// de la base al instante y lo dejaba hasta un minuto entero visible en la burbuja —
// Andy mandó el #12704 a la papelera y lo seguía viendo ahí y en el contador.
//
// Es un evento de ventana y no un contexto a propósito: los consumidores viven en
// ramas distintas del árbol (Layout, la burbuja, cualquier página futura) y ninguno
// necesita re-renderizar por esto, sólo volver a pedir sus datos.
const EVENT = 'tickets:changed';

export function notifyTicketsChanged() {
  try { window.dispatchEvent(new Event(EVENT)); } catch { /* SSR / entorno sin window */ }
}

// Devuelve la función de limpieza, así se usa directo como return de un useEffect.
export function onTicketsChanged(cb) {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
}
